export const delay = function () {
  return new Promise(function (resolve) {
    requestAnimationFrame(function () {
      requestAnimationFrame(resolve);
    });
  });
};

// export const debounce = function (fn, immediate) {
//   let waiting = true;
//   return function () {
//     const context = this, args = arguments;
//     const later = function () {
//       waiting = false;
//       if (!immediate) func.apply(context, args);
//     };

//     requestAnimationFrame(() =>
//       requestAnimationFrame(fn)
//     )
//   };
// }

// function debounce(func, wait, immediate) {
//   var timeout;
//   return function () {
//     var context = this, args = arguments;
//     var later = function () {
//       timeout = null;
//       if (!immediate) func.apply(context, args);
//     };
//     var callNow = immediate && !timeout;
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//     if (callNow) func.apply(context, args);
//   };
// };
